import React from "react"
import classnames from "classnames"
import {
  ColorIcon,
  P,
  Container,
  Interactive,
  Space,
  Visible
} from "AtomicComponents"
import styles from "./ColorPicker.less"
import {
  ImagesRotator,
  Image,
  Tooltip,
  HeroContent,
  Tabs
} from "AtomicContainers"
import gtmHandler from "AtomicUtils/gtmHandler"
import componentParser from "AtomicUtils/componentParser"


class ColorPicker extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {
      bodyStyleIndex: 0,
      colorIndex: 0,
    }
    this.ColorPicker = {}
  }

  _handleOnClickBodyStyle = (index) => {
    const { gtm, bodyStyles = [] } = this.props
    this.setState({
      bodyStyleIndex: index,
      colorIndex: 0,
    }, () => {
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        gtmHandler({
          pageCategory: gtm.category,
          pageAction: `${gtm.action} - Clicked "${bodyStyles[index].name}"`
        })
      }
    })
  }

  _handleChangeColor = (index) => {
    const { gtm, bodyStyles = [] } = this.props
    const { bodyStyleIndex } = this.state
    this.setState({
      colorIndex: index
    }, () => {
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        gtmHandler({
          pageCategory: gtm.category,
          pageAction: `${gtm.action} - Clicked "${bodyStyles[bodyStyleIndex].colors[index].name}" - "${bodyStyles[bodyStyleIndex].name}"`
        })
      }
    })
  }

  render() {
    const {
      heading,
      description,
      bodyStyles = [],
      components
    } = this.props

    const {
      mobileHeading=heading,
      mobileDescription=description
    } = this.props

    const {
      bodyStyleIndex,
      colorIndex
    } = this.state

    return (
      <div className={classnames({
        [styles.ColorPicker]: true
      })}>
        <div>
          <Visible visible={["screen","tablet"]}>
            { (heading || description) &&
              <HeroContent
                heading={heading}
                description={description} />
            }
          </Visible>
          <Visible visible={["mobile"]}>
            { (mobileHeading || mobileDescription) &&
              <HeroContent
                heading={mobileHeading}
                description={mobileDescription} />
            }
          </Visible>
        </div>
        <div className={classnames({
          [styles.Container]: true,
        })}>
          <div className={classnames({
            [styles.Tabs]: true,
          })}>
            {bodyStyles && bodyStyles.length > 1 &&
              <Tabs
                onClick={this._handleOnClickBodyStyle}
                scrolling
                divider
                options={bodyStyles.map(item=> {
                  return {
                    name: item.name
                  }
                })}
              />
            }
            <Tabs scrolling onClick={this._handleChangeColor}>
              {bodyStyles[bodyStyleIndex].colors.map((item, index) => {
                return (
                  <div
                    className={classnames({
                      [styles.ColorIcon]: true
                    })}
                    key={`colorIcon-${bodyStyleIndex}-${index}`}
                  >
                    <ColorIcon color={item.hex} active={colorIndex === index} />
                    <div
                      className={classnames({
                        [styles.Tooltip]: true,
                      })}>
                      <Tooltip size="small" position='bottomCenter' closeIcon={false}>
                        <P withoutMargin>
                          {item.name}
                        </P>
                      </Tooltip>
                    </div>
                  </div>
                )
              })}
            </Tabs>
          </div>
          <div>
            <Visible visible={["mobile"]}>
              <div style={{textAlign:'center', width: '100%'}}>
                <Space />
                <Interactive>
                  {bodyStyles[bodyStyleIndex].colors[colorIndex].name}
                </Interactive>
              </div>
            </Visible>
          </div>
          <div>
            <Space />
            <Space />
            <Container styleName="tablet-wide">
              {bodyStyles &&
                typeof bodyStyles[bodyStyleIndex].colors[colorIndex].src === "string" &&
                <Image
                  loadingTheme="light"
                  src={bodyStyles[bodyStyleIndex].colors[colorIndex].src}
                  type="spinner"
                />
              }
              {bodyStyles &&
                typeof bodyStyles[bodyStyleIndex].colors[colorIndex].src !== "string" &&
                <ImagesRotator
                  imagesSrc={bodyStyles[bodyStyleIndex].colors[colorIndex].src}
                />
              }
            </Container>
          </div>
          <div className={classnames({
            [styles.Children]: true,
          })}>
          {components && componentParser(components)}
          </div>
          <Space />
        </div>
      </div>
    )
  }
}


export default ColorPicker



// WEBPACK FOOTER //
// ./src/AtomicContainers/ColorPicker/ColorPicker.jsx